module.exports = __webpack_public_path__ + "static/media/LinotteBold.f32b52f0.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Linotte/LinotteBold.otf
// module id = 240
// module chunks = 0